import { useState } from 'react';
// @mui
import {
  Box,
  Button,
  Container,
  Typography,
} from "@mui/material";
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from "../../hooks/useResponsive";
// components
import Image from "../../components/Image";
import {
  ApplyFreePlanDialog
} from './';
import Page from "../../components/Page";
import DIOText from "../../components/DIOText";
// utils
import axios from '../../utils/axios';

export default function GuidePage() {
  const smUp = useResponsive('up', 'sm');
  const { user } = useAuth();
  const [isOpenScoutCallDialog, setIsOpenScoutCallDialog] = useState(false);

  const sendScoutStartClicked = async () => {
    try {
      const companyId = user?.employee.company?.[0]?.id;
      axios.post(`/api/company/${companyId}/scout/apply/`);
    } catch (err) {
      console.error(err);
    }
  }

  const scoutStartClicked = () => {
    sendScoutStartClicked();
    setIsOpenScoutCallDialog(true);
  }

  return (
    <Page title="Scout" sx={{ pb: { xs: 4, sm : 6 } }}>
      <Container maxWidth="laptop" sx={{ px: 3 }}>
        <Image src={"/icons/scout-logo.svg"} sx={{ width: "94px", height: "16px", color: "primary.main" }} />
        <Box sx={{ mt: 3 }} />
        <Box
          sx={{
            p: smUp ? 8 : 2,
            borderRadius: 2,
            bgcolor: "grey.200",
            height: smUp ? 'calc(100vh - 180px)' : 'calc(100vh - 144px)',
            minHeight: smUp ? "650px" : "450px",
            overflow: "clip",
          }}
        >
          <Typography variant={smUp ? "h3" : "h4"} sx={{ textAlign: "center", mt: { xs: 4, sm: 0 } }} gutterBottom>
            검증된 경력자 18,000+명으로<br />
            필요할 때 바로 투입할 프리랜서 그룹을 미리 준비하세요.
          </Typography>
          <Typography variant={smUp ? "body1": "body2"} sx={{ textAlign: "center" }} >
            고품질 프리랜서를 미리 확보하고,{!smUp && <br />} 나중에 필요할 때 즉시 활용해보세요.
          </Typography>
          <Box sx={{ mt: 3, mb: { xs: 4, sm: 5 }, width: 1, display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              size="large"
              color="primary"
              onClick={scoutStartClicked}
            >
              지금 무료로 시작하기
            </Button>
          </Box>
          {smUp ? (
          <Image
            disabledEffect
            visibleByDefault
            alt="dio-scout-intro"
            src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/scout/scout-intro.png"
            srcSet="
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/scout/scout-intro.png 1x,
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/scout/scout-intro-2x.png 2x,
            "
            sx={{
              width: '100%',
            }}
          />
          ):(
          <Image
            disabledEffect
            visibleByDefault
            alt="dio-scout-intro-mo"
            src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/scout/scout-intro-mo.png"
            srcSet="
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/scout/scout-intro-mo.png 1x,
              https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/scout/scout-intro-mo-2x.png 2x,
            "
            sx={{
              width: '100%',
            }}
          />
          )}
        </Box>
      </Container>
      <ApplyFreePlanDialog open={isOpenScoutCallDialog} closeDialog={() => setIsOpenScoutCallDialog(false)} />
    </Page>
  )
}
